export default {
  root: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'background.dark90',
    },
    '& > .MuiPaper-root': {
      borderRadius: '8px 0 0 8px',
      width: 'min(552px, 90vw)',
    },
  },
};
